import React, { Fragment, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { LoadingComponent } from 'recupero-comunes';
import Formulario from './formulario';
import { serviceGetCfgFormAumentoConciliar, serviceGetSolicitudAumentoConciliar, serviceGetHistorialAumentoConciliar, serviceGetDetalles } from '../../../api/api-aumento-conciliar';
import { getCasoImplicado } from '../../../api/api-visar-provision';

const AtenderAumentoConciliar = ({ showModal, setShowModal, implicado, idSolGestion, idTrxOrigen, onTareaGestionada }) => {

    const [loading, setLoading]           = useState(false);
    const [solicitud, setSolicitud]       = useState(null);
    const [coberturas, setCoberturas]     = useState([]);
    const [historial, setHistorial]       = useState([]);
    const [comboRespuesta, setComboRespuesta] = useState([]);
    const [involucrado, setInvolucrado]   = useState({});
    const [cfgForm, setCfgForm]           = useState(null);

    const data_encargado = useSelector((state) => state.encargadoCompaniaReducer);
    const { llaves } = data_encargado;

    useEffect(() => {
        if (showModal && idSolGestion) cargarDatos();
    }, [showModal, idSolGestion]);

    const cargarDatos = async () => {
        setLoading(true);
        try {
            const idCaso    = llaves?.idCaso;
            const idOrgCaso = llaves?.idOrgCaso;

            const qSolicitud  = Buffer.from(JSON.stringify({ idCaso, idImplicado: implicado, idSolGestion })).toString('base64');
            const qHistorial  = Buffer.from(JSON.stringify({ idCaso, idImplicado: implicado })).toString('base64');
            const qRespuesta  = Buffer.from(JSON.stringify({ concepto: 248, accion: 1 })).toString('base64');
            const qImplicado  = Buffer.from(JSON.stringify({ idCaso, idImplicado: implicado })).toString('base64');
            const qCfgForm    = Buffer.from(JSON.stringify({ rutcia: idOrgCaso, idform: 100 })).toString('base64');

            const [dataSolicitud, dataHistorial, dataRespuesta, dataImplicado, dataCfgForm] = await Promise.all([
                serviceGetSolicitudAumentoConciliar(qSolicitud),
                serviceGetHistorialAumentoConciliar(qHistorial),
                serviceGetDetalles(qRespuesta),
                getCasoImplicado(qImplicado),
                serviceGetCfgFormAumentoConciliar(qCfgForm).catch(() => null)
            ]);

            setSolicitud(dataSolicitud?.solicitud  || null);
            setCoberturas(dataSolicitud?.coberturas || []);
            setHistorial(dataHistorial || []);
            setComboRespuesta((dataRespuesta || []).filter(item => Number(item.accion) == 1));
            setCfgForm(dataCfgForm || null);

            const impl = dataImplicado?.[0];
            setInvolucrado({
                rut      : impl?.RutInvolucrado       || '',
                nombre   : impl?.NombreInvolucrado    || '',
                tipo     : impl?.GlosaTipoInvolucrado || '',
                patente  : impl?.Patente              || '',
                lesionado: impl?.GlosaImplLesionado   || ''
            });
        } catch (error) {
            console.log('Error al cargar datos aumento conciliar:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => setShowModal(false);

    return (
        <Fragment>
            <Modal show={showModal} onHide={handleClose} size='xl'>
                <LoadingComponent show={loading} />
                <Formulario
                    showModal={showModal}
                    setShowModal={setShowModal}
                    implicado={implicado}
                    idSolGestion={idSolGestion}
                    idTrxOrigen={idTrxOrigen}
                    solicitud={solicitud}
                    coberturas={coberturas}
                    historial={historial}
                    comboRespuesta={comboRespuesta}
                    involucrado={involucrado}
                    cfgForm={cfgForm}
                    recargarDatos={cargarDatos}
                    onTareaGestionada={onTareaGestionada}
                />
            </Modal>
        </Fragment>
    );
};

export default AtenderAumentoConciliar;
